export default {"en-US": __webpack_public_path__ + "i18n/en-US.972d588f.i18next.json"};